<template>
    <div>
        <view-nav title="Movix history"/>

        <div class="view-content container-fluid">
            <div class="row">
                <div class="col-2">
                    <ul class="box nav">
                        <li class="nav-item w-100">
                            <router-link to="/history/search" exact-path class="nav-link">
                                <icon name="search" class="red"></icon> Search
                            </router-link>
                        </li>
                    </ul>
                    <div class="box">
                        <div class="box-content">
                            <heading upper="Help" border>
                                <template v-slot:lower>
                                    Search compiled movie history records by title or Movix ID.
                                    Open a row to see the full breakdown and re-compile from there.
                                </template>
                            </heading>
                        </div>
                    </div>
                </div>
                <div class="col-10">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Heading from "../partials/Heading";
import ViewNav from "../partials/ViewNav";

export default {
    components: {
        Heading,
        ViewNav,
    },
}
</script>
